import { v4 as uuidV4 } from 'uuid';

export function getInitials(user: Record<string, any>): string {
  const firstName = user.firstName;
  const lastName = user.lastName;
  return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
}

/**
 * Generates a cryptographically secure random ID string.
 * Security: uses uuidv4 instead of Math.random() or crypto.getRandomValues()
 * to produce an unpredictable, standards-based ID.
 */
export function generateRandomId(): string {
  return uuidV4().replace(/-/g, '') + Date.now().toString(36);
}

export function getAllDefaultPrompts(): string[] {
  return Object.values(DEFAULT_PROMPTS_BY_ENTITY.lease).flat();
}

export function getDefaultPromptsByEntity(entity: string): string[] {
  return DEFAULT_PROMPTS_BY_ENTITY[entity] || [];
}

// Map of default prompts by entity
export const DEFAULT_PROMPTS_BY_ENTITY: Record<string, string[]> = {
  lease: [
    'Give me a list of all current <Office/Retail/Industrial> leases in the <Market/Submarket/District/Neighborhood> between the sizes of <Min SF> and <Max SF>',
    'Give me a list of all  <Office/Retail/Industrial> leases in the <Market/Submarket/District/Neighborhood> expiring after <Date> or between <Date 1> and <Date 2>',
    'Give me a list of all leases in the <Market/Submarket/District/Neighborhood> where <Company Name> was the Tenant ',
    'Give me a list of all leases in the <Market/Submarket/District/Neighborhood> where <Company Name> was the <Listing Rep/Tenant Rep>',
    'Give me the footprint of <Parent Company> in the <Market/Submarket/District/Neighborhood>',
  ],
  availability: [
    'Give me a list of all current <Office/Retail/Industrial> Availabilities in the <Market/Submarket/District/Neighborhood> between the sizes of <Min SF> and <Max SF> considering the Maximum contiguous space',
    'Give me a list of all current <Office/Retail/Industrial> Availabilities in the <Market/Submarket/District/Neighborhood> where the Listing Rep is <Company Name>',
    'Give me a list of all current <Office/Retail/Industrial> Availabilities in the <Market/Submarket/District/Neighborhood> between the sizes of <Min SF> and <Max SF> considering the Maximum contiguous space with the Asking Rate between <Min> and <Max>',
  ],
  property: [
    'Give me a summary of <Property Name /Address> including details of the Availabilities and Leases ',
    'Give me a list of <Office/Retail/Industrial> Properties with contiguous Availability over <X SF> in the <Market/Submarket/District/Neighborhood> ',
    'Give me a list of <Office/Retail/Industrial> Properties with contiguous Availability over <X SF> in the <Market/Submarket/District/Neighborhood> where the Asking Rate is between <$x> and <$y> ',
  ],
  company: [
    "Of the Companies with the name <Company Name> as a Tenant on Leasesin <Market/Submarket>, which one has the most deals associated with it? Please provide the Company ID and how many deals it's associated with",
  ],
};

export const ENTITY_BY_PROMPT_MAP: Record<string, Record<string, string[]>> = {
  lease: { leases: DEFAULT_PROMPTS_BY_ENTITY.lease },
  availability: { availabilities: DEFAULT_PROMPTS_BY_ENTITY.availability },
  property: { property: DEFAULT_PROMPTS_BY_ENTITY.property },
  company: { company: DEFAULT_PROMPTS_BY_ENTITY.company },
};
